import { useResource } from '@landsbankinn/l16n';
import {
  Box,
  ColResponsive,
  Flex,
  P,
  RowResponsive,
  LTMLogoIcon100,
  TopBarHomeButton,
} from '@landsbankinn/ui-kit';
import { getLandsbankinnUrlByLocale } from '../../getLandsbankinnUrlByLocale';
import { useHeaderTitle } from '../../useHeaderTitle';
import { CultureDropdown } from './CultureDropdown';
import { useBrand } from 'src/hooks/useBrand';
import { useApplicationServerContext } from 'src/state';

export const HEADER_HEIGHT = '80';

export function Header() {
  const title = useHeaderTitle();
  const { locale } = useResource();
  const [{ isNativeAppClient }] = useApplicationServerContext();

  const brand = useBrand();

  return (
    <RowResponsive
      backgroundWidth="full width"
      as="header"
      height={HEADER_HEIGHT}
      shrink="0"
      background={brand === 'TM' ? 'green main' : 'common gradients darkBlue'}
    >
      <ColResponsive xs={8} mainAxisAlignment="center">
        {brand === 'TM' ? (
          <Flex direction="row" crossAxisAlignment="center" colGap="14">
            <LTMLogoIcon100 height="50" width="90" color="common white" />
            <P
              fontVariant="body"
              fontWeight="medium"
              letterSpacing=".5"
              color="common white"
            >
              {title}
            </P>
          </Flex>
        ) : (
          <>
            <Box
              paddingRight="20"
              paddingLeft="2"
              position="absolute"
              left="-68"
            >
              <TopBarHomeButton
                instrumentAs="go_to_home_screen"
                onClick={() => {
                  if (!isNativeAppClient) {
                    window.location.href = getLandsbankinnUrlByLocale(locale);
                  }
                }}
                color="red logo"
              />
            </Box>
            <P
              fontVariant="body"
              fontWeight="medium"
              letterSpacing=".5"
              color="common white"
            >
              {title}
            </P>
          </>
        )}
      </ColResponsive>
      <ColResponsive xs={4} crossAxisAlignment="end" mainAxisAlignment="center">
        <CultureDropdown />
      </ColResponsive>
    </RowResponsive>
  );
}
